/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "ap-south-1",
    "aws_cloud_logic_custom": [
        {
            "name": "moodlecourseenrol",
            "endpoint": "https://fnvi6h1q83.execute-api.ap-south-1.amazonaws.com/live",
            "region": "ap-south-1"
        },
        {
            "name": "welcomeemaildev",
            "endpoint": "https://op19j40fk6.execute-api.ap-south-1.amazonaws.com/live",
            "region": "ap-south-1"
        }
    ],
    "aws_appsync_graphqlEndpoint": "https://yz4yqqccxndvbjjnj3b3jwrbqe.appsync-api.ap-south-1.amazonaws.com/graphql",
    "aws_appsync_region": "ap-south-1",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-tlpl5jkkxjf7ng4vxx6eg2k22e",
    "aws_cognito_identity_pool_id": "ap-south-1:22e320b1-8100-496c-a169-99c2f5f677d2",
    "aws_cognito_region": "ap-south-1",
    "aws_user_pools_id": "ap-south-1_OHqnTO1Bc",
    "aws_user_pools_web_client_id": "2168karlmdd553hqpu24mqrk67",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "BIRTHDATE",
        "EMAIL",
        "GENDER",
        "NAME"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "newmysphere100602-live",
    "aws_user_files_s3_bucket_region": "ap-south-1"
};


export default awsmobile;
